<template>
  <div class="bg-magnolia ptb-100">
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="login-img">
            <img src="../../assets/img/login-img.webp" alt="Image" />
          </div>
        </div>
        <div class="col-lg-6 mt-md-30">
          <h2 class="fs-34 mb-35">Send Your Message</h2>
          <form class="form-wrap" id="contactForm">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <input
                    type="email"
                    name="email"
                    id="email"
                    class="br-four round-6 bg-transparent w-100"
                    placeholder="Your email"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input
                    type="number"
                    name="phone"
                    id="phone"
                    class="br-four round-6 bg-transparent w-100"
                    placeholder="Your phone"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input
                    type="text"
                    name="name"
                    id="name"
                    class="br-four round-6 bg-transparent w-100"
                    placeholder="Your name"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <input
                    type="text"
                    name="subj"
                    id="subj"
                    class="br-four round-6 bg-transparent w-100"
                    placeholder="Subject"
                  />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <textarea
                    name="message"
                    id="message"
                    class="h-172 br-four round-6 bg-transparent w-100 resize-0"
                    cols="30"
                    rows="10"
                    required
                    placeholder="Your message here"
                  ></textarea>
                </div>
              </div>
              <div class="col-12">
                <div class="form-group">
                  <div class="form-check checkbox">
                    <input
                      name="gridCheck"
                      value="I agree to the terms and privacy policy."
                      class="form-check-input"
                      type="checkbox"
                      id="gridCheck"
                      required
                    />
                    <label class="form-check-label" for="gridCheck">
                      I agree to the
                      <router-link class="link-one" to="/terms-conditions">
                        Terms &amp; Conditions
                      </router-link>
                      and
                      <router-link class="link-one" to="/privacy-policy">
                        Privacy Policy
                      </router-link>
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-12">
                <button type="submit" class="btn style-one d-block w-100">
                  Send Message
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactForm",
};
</script>

<style lang="scss" scoped>
#contactForm {
  .form-group {
    margin-bottom: 20px;
    input {
      &::placeholder {
        color: #9998a0;
        opacity: 1;
      }
    }
  }
}
</style>